export default __webpack_public_path__ + "static/media/buick.8d95515f.png";